(function() {

    'use strict'

    angular
        .module('jotApp')
        .filter('fleetFilter', fleetFilter);

    function fleetFilter() {
        return fleetFilterFunction;

        function fleetFilterFunction (objList, expression) {
            var filteredList = [];
            // no filter specified
            if(expression != undefined){
                if (expression.name === "" && expression.category === "") {
                    filteredList = objList;
                } else {
                    angular.forEach(objList, function (value) {
                        var toPush = true;
                        // filter for name
                        if (value.objectName !== "" && !value.objectName.toLowerCase().includes(expression.name)) {
                            toPush = false;
                        }
                        // filter for objectUniqueCode && name
                        if ((value.objectUniqueCode !== "" && !value.objectUniqueCode.toLowerCase().includes(expression.objectUniqueCode.toLowerCase())) &&
                            (value.objectName !== "" && !value.objectName.toLowerCase().includes(expression.objectUniqueCode.toLowerCase()))) {
                            toPush = false;
                        }
                        //filter for type
                        if (expression.type !== 'ALL' && (value.objectType.objectTypeName+'') !== expression.type) {
                            toPush = false;
                        }
                        //filter for category
                        // if (expression.category !== 'all' && (value.cat+'') !== expression.category) {
                        //     toPush = false;
                        // }
                        if (toPush)
                            filteredList.push(value);
                    });
                }
            }
            return filteredList;
        }
    }

})();
